import React from 'react';
import { HeaderSection } from './HeaderSection';
import { MainSection } from './MainSection';
import './index.css';

const MainPage = () => {
  return (
    <div>
      <HeaderSection />
      <MainSection />
    </div>
  );
};

export default MainPage;
